const defaultState = {
  size: "mini",
  open: false,
  onCancel: null,
  cancelText: "Cancel",
  onConfirm: null,
  content: "",
  confirmText: "OK",
  confirmColor: "blue",
};

const ConfirmationModal = (state = defaultState, action) => {
  switch (action.type) {
    case "SHOW_CONFIRM_DIALOG":
      return {
        ...state,
        ...action.options,
        open: true,
      };

    case "HIDE_CONFIRM_DIALOG":
      return defaultState;

    default:
      return state;
  }
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/reducers/ConfirmationModal/index.js